import { render, staticRenderFns } from "./AdvertisementList.vue?vue&type=template&id=d2c0163a&scoped=true"
import script from "./AdvertisementList.vue?vue&type=script&lang=js"
export * from "./AdvertisementList.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementList.vue?vue&type=style&index=0&id=d2c0163a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c0163a",
  null
  
)

export default component.exports